import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AppTranslateService } from 'src/app/service/core/app-translate.service';
import { UserProfileService } from 'src/app/service/userProfile.service';
import { HelperService } from '../helper.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent extends HelperService implements OnInit {
  navigationArray: any[];
  lang: string = null;
  userProfile: any = null;
  constructor(
    private appTranslateService: AppTranslateService,
    private userProfileService: UserProfileService,
    private router: Router) {
    super();

    this.userProfile = this.userProfileService.getProfile();


    this.lang = appTranslateService.getCurrentLang();

    this.navigationArray = [
      {
        "id": 1,
        "link": "/",
        "linkText": "homePage"
      },
      {
        "id": 2,
        "linkText": "services",
        "child": true,
        "submenu": [
          {
            "id": 1.1,
            "link": "/customer/requestService/1",
            "linkText": "legalNotification"
          },
          {
            "id": 1.2,
            "link": "/customer/requestService/2",
            "linkText": "publishing"
          }
        ]
      },
      {
        "id": 3,
        "link": "/",
        "linkText": "aboutUs"
      },
      {
        "id": 4,
        "link": "/",
        "linkText": "contactUs"
      },
    ];
  }

  ngOnInit(): void {

    this.router.events.subscribe((evt) => {

      if (evt instanceof NavigationStart) {
        this.userProfile = this.userProfileService.getProfile();
      }
    });
  }


  changeLanguage() {
    if (this.lang === 'ar') {
      localStorage.setItem("lang", "en");
    } else {
      localStorage.setItem("lang", "ar");
    }
    location.reload();
  }

  goToDiv(divId) {
    var isNotHome = false;
    if (this.router.url !== "/") {
      this.router.navigate(["/"]);
      isNotHome = true;;
    }
    const firstElementWithError = document.querySelector('#' + divId);

    if (firstElementWithError) {
      if (isNotHome === true) {
        setTimeout(() => {
          $('html, body').animate({
            scrollTop: $(firstElementWithError).offset().top - 100
          }, 1000);
        }, 2000);

      } else {
        $('html, body').animate({
          scrollTop: $(firstElementWithError).offset().top - 100
        }, 1000);
      }
    }
  }

  logout() {
    this.userProfileService.clearProfile();
    this.userProfile = null;
    this.router.navigate(["/account/login"]);
  }
}
